"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHeaderNotification = exports.StyledHeaderUserProfileLanguage = exports.StyledHeaderTabs = exports.StyledHeaderRightBox = exports.StyledHeaderWrapper = void 0;
const theme_1 = require("@icr-ui/theme");
const utils_1 = require("@icr-ui/utils");
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../../general");
exports.StyledHeaderWrapper = (0, styled_components_1.default)(general_1.Paper) `
  ${({ tabsProps }) => (0, styled_components_1.css) `
    z-index: 300;
    padding: 0 ${theme_1.spacings.s8};
    position: relative;
    height: ${theme_1.spacings.s12};

    @media (max-width: 833px) {
      height: ${tabsProps ? (0, utils_1.pxToRem)(110) : theme_1.spacings.s12};
      padding: 0 ${theme_1.spacings.s5};
    }
  `}
`;
exports.StyledHeaderRightBox = (0, styled_components_1.default)(general_1.Flexbox) ``;
exports.StyledHeaderTabs = (0, styled_components_1.default)(general_1.Flexbox) `
  height: 100%;
  align-self: flex-end;
  @media (max-width: 833px) {
    height: 34px;
    order: 3;
    justify-self: center;
    width: 100%;
  }
`;
exports.StyledHeaderUserProfileLanguage = styled_components_1.default.div `
  padding: 0;
`;
exports.StyledHeaderNotification = styled_components_1.default.div `
  padding: 0;
  @media (max-width: 833px) {
    display: none;
  }
`;
//# sourceMappingURL=styles.js.map